
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/collapse",
      function () {
        return require("private-next-pages/components/collapse.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/collapse"])
      });
    }
  